// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"642a173e464e9918f689","293":"9e6c164e739d361d7398","518":"9960b254da52be8b94c4","779":"24802f7969fbf80e37b0"}[chunkId] + ".js";
};